import React, { useState, useEffect } from "react";
import { Form, Button, Table, Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./membercss/Member.css";
import Breadcrumb from "app/components/Breadcrumb";
import { IoIosSearch } from "react-icons/io";
import Identity from "./Identity";
import Advance from "./Advance";
import useTranslations from "../transalation/TranslationUtils";
import { useSelector } from "react-redux";
import { getMembersByPage, resetAllMemberPageData, searchMembersByPage } from "app/redux/slices/rdxMemberSlice";
import { useDispatch } from "react-redux";
import { TAB_MEMBER_LIST_ADVANCE, TAB_MEMBER_LIST_IDENTITY, TAB_MEMBER_LIST_SEARCH } from "app/utils/constant";

const Member = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useState({
    cat: "Name",
    keyword: "",
    first: true
  });

  const [prevParams, setPrevParams] = useState({
    cat: "Name",
    keyword: "",
    first: false
  });

  const [page, setPage] = useState(0);
  const [hasLoadMore, setHasLoadMore] = useState(false);
  const [memberList, setMemberList] = useState([]);

  const permissions = useSelector((state) => state.rdxMain?.pagePermissions?.account || {});
  const audienceIdMap = useSelector((state) => state.rdxMain?.audienceIdMap || {});

  const {
    membermange,
    mAdd,
    searchmember,
    usersearch,
    result,
    membername,
    joineddate,
    mobile,
    memberid,
    cardref,
    app1st,
    memberidentity,
    func_t,
    nomemberfound,
    mEdit,
    role_next,
    role_previous,
    midentity,
    mAdvance,
    searchformemberm,
    showErrMsg,
    i18nObj,
    mFreeUser,
    mPaidUser,
    membershipLevel,
    pushreset,
    loadMore
  } = useTranslations();

  const handleAddMember = () => {
    navigate("/member/memberinfo");
  };

  const handleEditMember = (member) => {
    navigate("/member/memberinfo?account_id=" + member.account_id);
  };

  useEffect(() => {
    return () => {
      // Component unmount logic
      dispatch(resetAllMemberPageData())
    };
  }, []);

  useEffect(() => {
    if (searchParams) {
      if (searchParams.cat != prevParams.cat ||
        searchParams.keyword != prevParams.keyword) {
        setHasLoadMore(false);
      } else if ("Name" == searchParams.cat &&
        searchParams.first &&
        !searchParams.keyword) {
        //reset search and page init search here
        handleSearch(false);
      }
    }
  }, [searchParams]);

  const handleSearchOptionChange = (e) => {
    let nextInput;

    //選擇account_identity 時 預選 level 選項1
    if ("MemberShip Level" == e.target.value) {
      nextInput = "free";
    } else {
      nextInput = "";
    }

    setSearchParams((prev) => ({
      ...prev,
      cat: e.target.value,
      keyword: nextInput,
      first: false
    }));
  };

  const handleSearchInputChange = (e) => {
    setSearchParams((prev) => ({
      ...prev,
      keyword: e.target.value,
      first: false
    }));
  };

  const handleSearch = (hasNext) => {
    let isSearchMode = true;
    if (searchParams.first ||
      searchParams.cat == "All") {
      isSearchMode = false;
    }

    let mPage = 1;
    if (!hasNext) {
      setPrevParams(searchParams);
      setPage(mPage);
    } else {
      mPage = page + 1;
      setPage(mPage);
    }

    let callback = (isSuccess, data) => {
      if (isSuccess) {
        if (mPage > 1) {
          console.log("more");
          if (!data.data?.data || !Array.isArray(data.data?.data) || data.data?.data.length == 0) {
            setHasLoadMore(false);
          } else {
            setHasLoadMore(true);
            const newList = [...memberList];
            data.data?.data.forEach((item) => {
              newList.push(item);
            })
            setMemberList(newList);
          }
        } else {
          console.log("first");
          if (!data.data?.data || !Array.isArray(data.data?.data) || data.data?.data.length == 0) {
            setHasLoadMore(false);
          } else {
            setHasLoadMore(true);
          }

          if (Array.isArray(data.data?.data)) {
            setMemberList(data.data?.data);
          } else {
            setMemberList([]);
          }
        }
      } else {
        let revertPage = mPage - 1;
        if (revertPage < 1) {
          revertPage = 1;
        }
        setPage(revertPage);
        alert(showErrMsg(data));
      }
    }

    if (isSearchMode) {
      let sendData = {
        cat: searchParams.cat,
        keyword: searchParams.keyword
      }

      dispatch(searchMembersByPage(mPage, sendData, callback));
    } else {
      dispatch(getMembersByPage(mPage, callback));
    }
  };

  const handleReset = () => {
    setSearchParams({
      cat: "Name",
      keyword: "",
      first: true
    });

    setPrevParams({
      cat: "Name",
      keyword: ""
    });

    //trigger reset search in searchParams's useEffect
  };

  const [activeTab, setActiveTab] = useState(TAB_MEMBER_LIST_SEARCH);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  function formatDate(input, format = "date") {
    let date;

    if (!input) {
      return "";
    } else if (typeof input === "string") {
      date = new Date(input);
    } else if (typeof input === "number") {
      date = new Date(input);
    } else if (Array.isArray(input) && input.length === 1 && typeof input[0] === "number") {
      date = new Date(input[0]);
    } else {
      return "Invalid";
    }

    // Ensure the Date object is valid
    if (isNaN(date.getTime())) {
      return "Invalid";
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    if (format === "date") {
      return `${year}-${month}-${day}`;
    } else if (format === "datetime") {
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
      return "Invalid";
    }
  }

  return (
    <Container fluid style={{ padding: "0" }}>
      <Row className="ps-4 pt-4 align-items-center">
        <Col>
          <Breadcrumb routeSegments={[{ name: membermange() }]} />
        </Col>
        <Col className="text-end me-4">
          {(activeTab === TAB_MEMBER_LIST_SEARCH || activeTab === TAB_MEMBER_LIST_IDENTITY || activeTab === TAB_MEMBER_LIST_ADVANCE) &&
            permissions.add && (
              <Button className="custom-success-btn me-2" onClick={handleAddMember}>
                {mAdd()}
              </Button>
            )}
        </Col>
      </Row>

      <Row className="ps-4 g-0 me-4 mt-5">
        <Col xs={12} md={4} className="d-flex justify-content-between">
          {[TAB_MEMBER_LIST_SEARCH
            // , TAB_MEMBER_LIST_IDENTITY, TAB_MEMBER_LIST_ADVANCE
          ].map((tab, index) => (
            <div
              key={index}
              className={`tab-link ${activeTab === tab ? "active" : ""}`}
              onClick={() => handleTabClick(tab)}
              style={{
                cursor: "pointer",
                fontWeight: activeTab === tab ? "bold" : "normal",
                color: activeTab === tab ? "blue" : "black",
                paddingBottom: "5px",
                borderBottom: activeTab === tab ? "2px solid blue" : "none",
              }}
            >
              {TAB_MEMBER_LIST_SEARCH == tab ? (
                searchformemberm()
              ) : TAB_MEMBER_LIST_IDENTITY == tab ? (
                midentity()
              ) : TAB_MEMBER_LIST_ADVANCE == tab ? (
                mAdvance()
              ) : (<React.Fragment></React.Fragment>)}
            </div>
          ))}
        </Col>
      </Row>

      {/* Conditional Rendering of Components Based on Active Tab */}
      {activeTab === TAB_MEMBER_LIST_SEARCH && (
        <Row className="ps-4 g-0 me-4">
          <Col xs={12} md={{ span: 12 }}>
            <Card
              className="mt-4 mb-4 custom-shadow"
              style={{ margin: "0", padding: "0", width: "100%" }}
            >
              <Card.Body>
                <Row className="d-flex align-items-center">
                  <Col md={6}>
                    <h4 className="search-heading">{searchmember()}</h4>
                  </Col>
                  {/* <Col md={6} className="text-end">
                   {permissions.add && (
                     <Button
                       variant="success"
                       className="custom-success-btn me-2"
                       onClick={handleAddMember}
                     >
                       Add
                     </Button>
                   )}
                 </Col> */}
                </Row>


                <hr />

                <Row className="mt-3">
                  <Col xs={12} className="row align-items-center" style={{ "maxWidth": "900px" }}>
                    <div className="col-12 col-md-4 mb-2 pe-0">
                      <Form.Select
                        aria-label="Member ID Select"
                        className="custom-select me-2"
                        style={{ height: "29px", padding: "0 8px" }}
                        value={searchParams.cat}
                        onChange={handleSearchOptionChange}
                      >
                        <option value="All">All</option>
                        <option value="Name">Name</option>
                        <option value="Email">Email</option>
                        <option value="Member ID">Member ID</option>
                        <option value="Mobile">Mobile</option>
                        <option value="Card Ref">Card Ref</option>
                        <option value="Account ID">Account ID</option>
                        <option value="MemberShip Level">MemberShip Level</option>
                      </Form.Select>
                    </div>

                    {searchParams.cat != "All" && (
                      <div className="col-12 col-md-5 mb-2 pe-0">
                        {searchParams.cat === "MemberShip Level" && (
                          <Form.Select
                            name="account_level"
                            value={searchParams.keyword}
                            onChange={handleSearchInputChange}
                            className="custom-select me-2"
                            style={{ height: "29px", padding: "0 8px" }}>
                            <option key="free" value="free">{mFreeUser()}</option>
                            <option key="paid" value="paid">{mPaidUser()}</option>
                          </Form.Select>
                        )}
                        {searchParams.cat !== "MemberShip Level" && (
                          <Form.Control
                            type="text"
                            className="custom-search-member me-2"
                            style={{ height: "29px", padding: "0 8px" }}
                            value={searchParams.keyword}
                            onChange={handleSearchInputChange}
                          />
                        )}
                      </div>
                    )}

                    <div className="mb-2 d-flex" style={{ width: "200px" }}>
                      <Button
                        variant="success"
                        className="custom-success-btn"
                        style={{ marginLeft: "0px" }}
                        onClick={() => { handleSearch(false); }}>{usersearch()}</Button>
                      <Button
                        variant="success"
                        className="custom-success-btn"
                        onClick={handleReset}>{pushreset()}</Button>
                    </div>
                  </Col>
                </Row>

              </Card.Body>
            </Card>
          </Col>

          <Row className="mt-5">
            <Col xs={12}>
              <h4 className="member-result">{result()}</h4>
            </Col>
          </Row>
          <hr />

          <Row className=" me-3">
            <Col xs={12} md={{ span: 12 }}>
              <Table
                striped
                hover
                responsive
                className="centered-table"
                style={{ margin: "0", padding: "0", width: "100%" }}
              >
                <thead>
                  <tr>
                    <th className="custom-th">{membername()}</th>
                    <th className="custom-th">{joineddate()}</th>
                    <th className="custom-th">{mobile()}</th>
                    <th className="custom-th">{memberid()}</th>
                    <th className="custom-th">{cardref()}</th>
                    <th className="custom-th">Email</th>
                    <th className="custom-th">{app1st()}</th>
                    <th className="custom-th">{memberidentity()}</th>
                    <th className="custom-th">{func_t()}</th>
                  </tr>
                </thead>
                <tbody>
                  {memberList.length > 0 ? (
                    memberList.map((member, index) => (
                      <tr key={index}>
                        <td className="custom-td">{member.account_name}</td>
                        <td className="custom-td">{formatDate(member.create_date, "date")}</td>
                        <td className="custom-td">{member.account_phone}</td>
                        <td className="custom-td">{member.member_id}</td>
                        <td className="custom-td">{member.card_ref}</td>
                        <td className="custom-td">{member.account_email}</td>
                        <td className="custom-td">{formatDate(member.first_login_date, "date")}</td>
                        <td className="custom-td">{i18nObj(audienceIdMap[member.account_identity]?.audience_name)}</td>
                        <td className="custom-td">
                          {permissions.edit && (
                            <Button
                              variant="success"
                              className="custom-success-btn me-2"
                              onClick={() => handleEditMember(member)}
                            >
                              {mEdit()}
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        {nomemberfound()}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {hasLoadMore && (<div className="d-flex justify-content-center mt-3">
                <Button variant="outline-success"
                  className="custom-outline-success" onClick={() => handleSearch(true)}>{loadMore()}</Button>
              </div>)}
              <div className="mb-5"></div>
            </Col>
          </Row>

        </Row>
      )}
      {/* {activeTab === TAB_MEMBER_LIST_IDENTITY && <Identity />}
      {activeTab === TAB_MEMBER_LIST_ADVANCE && <Advance />} */}
    </Container>
  );
};

export default Member;

